var CartCtrl = function(gettextCatalog, $state, $sessionStorage, Notification, items, Order) {
  this._Notification = Notification;
  this._Order = Order;
  this._state = $state;
  this._sessionStorage = $sessionStorage;
  this.gettextCatalog = gettextCatalog;
  this.items = items;
  this.deliveryItems = [];
  this.sum = 0;
  const allScooter = this._sessionStorage.items.every((item) => item.type === 'scooter');
  this.type = allScooter ? 'scooter' : 'part';

  this.deliveryTypeChanged();
};

CartCtrl.prototype.order = function() {
  var self = this;

  this._Order.create({
      items: this.items,
      deliveryItems: this.deliveryItems,
      comment: this.comment
    },
    function() {
      self._Notification.success(self.gettextCatalog.getString('Besten Dank für Ihre Bestellung. Die Auftragsbestätigung erhalten Sie per Email.'));
      self._sessionStorage.$reset({
        items: [],
        stock: [],
        deliveryType: null
      });
      self._state.go('app.orderlist', {type: 'scooter'});
    }, function() {
      self._Notification.error(self.gettextCatalog.getString('Bestellung konnte nicht abgesendet werden'));
    });
  
};

CartCtrl.prototype.removeItem = function(index) {
  this.items.splice(index, 1);

  this.deliveryTypeChanged();
};

CartCtrl.prototype.deliveryTypeChanged = function() {
  if (this._sessionStorage.deliveryType === 'shipping') {
    this.generateDeliveryItems();
  } else {
    this.deliveryItems = [];
  }

  this.calcSum();
};

CartCtrl.prototype.isDisabled = function () {
  return !this.agb;
};

CartCtrl.prototype.generateDeliveryItems = function() {
  var self = this;
  this.deliveryItems = [];
  var partSum = 0;

  _.forEach(this.items, function(item) {
    if (item.type === 'part') {
      partSum += _.toNumber(item.sale_price) * _.toNumber(item.order_number);
    } else if (item.type === 'scooter') {
      self.deliveryItems.push({
        intern_name: 'Lieferkosten für ' + item.intern_name,
        sale_price: _.toNumber(item.deliverer_description) * _.toNumber(item.order_number),
        type: 'deliveryCosts'
      });
    }
  });
  
  // if (partSum > 0 && partSum < 200) {
  //   this.deliveryItems.push({
  //     intern_name: 'Lieferpauschale Ersatzteile',
  //     sale_price: 15,
  //     type: 'deliveryCosts'
  //   });
  // }
};

CartCtrl.prototype.calcSum = function() {
  var self = this;
  this.sum = 0;
  
  _.forEach(this.items, function(item) {
    self.sum += _.toNumber(item.sale_price) * _.toNumber(item.order_number);
  });
  
  _.forEach(this.deliveryItems, function(item) {
    self.sum += _.toNumber(item.sale_price);
  });
};

module.exports = CartCtrl;



// WEBPACK FOOTER //
// ./client/src/app/modules/order/CartCtrl.js